import React from "react"
import DynamicCard from "../Common/DynamicCard"
import WhyUsJSON from "../../Configs/JSON/WhyUs.json"
import "./WhyUs.less"
export default function WhyUs() {
  return (
    <div className="WhyUsSectionWrapper">
      <h2 className="sectionTitle" dangerouslySetInnerHTML={{ __html: WhyUsJSON.HeaderText }}></h2>

      <DynamicCard
        data={WhyUsJSON.HeaderPhone}
        title={true}
        dot={true}
        icon={true}
        arrow={false}
        content={false}
     
        wrapperStyle={"ButtonWrapper"}
        iconStyle={"ButtonIcon"}
        titleStyle={"ButtonTitle"}
        onClick={() => (document.location.href = `tel:${WhyUsJSON.HeaderPhone.NumberURL}`)}
      />
    </div>
  )
}
